export enum CalculatorTabName {
  Simplified = "Simplified",
  Detailed = "Detailed",
}

export const CALCULATOR_STYLES = {
  default: "px-[16px] py-[10px]",
  tabContainer:
    "w-fit border-[1px] border-[#E2E2E2] bg-white rounded-[54px] mt-[24px] mb-[28px] text-[16px] leading-[127%] font-normal",
  tabButton: "border-[#E2E2E2]",
  leftTab: "rounded-l-[54px] border-r-[0.5px]",
  rightTab: "rounded-r-[54px] border-l-[0.5px]",
  activeTab: "bg-[#F9F9F9]",
};

export const TAB_SHADOWS = {
  active: "0px 2px 1px 0px rgba(0, 0, 0, 0.05) inset",
  inactive:
    "0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px -2px 1px 0px rgba(0, 0, 0, 0.07) inset",
};

export const DEFAULT_CALCULATOR_VALUES = {
  ANNUAL_SALARY: 100000,
  EMPLOYER_MATCH_RATE: 100,
  MAX_EMPLOYER_MATCH_SALARY_RATE: 6,
  MAX_ANNUAL_CONTRIBUTION: 6000,
  ANNUAL_GROWTH_RATE: 7,
};
